import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';

import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import Input from '../../shared/components/FormElements/Input';
import Button from '../../shared/components/UIElements/Buttons/Button';

import './UpdatePortLanguage.css';

const UpdatePortCurrency = ({id, currency}) => {

    const auth = useContext(AuthContext);
    const { isLoading, sendRequest } = useHttpClient();
    const { register, handleSubmit} = useForm();
    const [loadedCurrency, setLoadedCurrency] = useState('');

    useEffect(() => {
        currency && setLoadedCurrency(currency);
    }, [currency])

    const updateCurrencyHandler = data => {
        console.log(data);
        setLoadedCurrency(data.currency);
    };

    const onSubmit = async (data) => {

        try {
            const response = await sendRequest(
              `https://api.docked.co/api/ports/update-port/currency/${id}`,
              'PATCH',
              JSON.stringify({
                currency: data.currency
              }),
              {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + auth.token,
              }
            );
            console.log(response);
            
          } catch (err) {
            console.log(err);
          }
    }

    return (
        <form className='update-port-lang-form' onSubmit={handleSubmit(onSubmit)}>
        <Input
              id="currency"
              name="currency"
              type="text"
              groupFront="Currency"
              refs={register()}
              value={loadedCurrency}
              onChange={updateCurrencyHandler}
            />
           {!isLoading ?  <Button className='btn-lang-update' title='update' type='submit' /> : <p>Loading...</p>}
        </form>
    )
}

export default UpdatePortCurrency;